import { render } from "./RequisitionsMadeReportTab.vue?vue&type=template&id=b3082fce"
import script from "./RequisitionsMadeReportTab.vue?vue&type=script&lang=js"
export * from "./RequisitionsMadeReportTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__